import React, {useContext, useEffect, useMemo} from "react"
import {NavLink, useLocation} from "react-router-dom";
import {RouteContext} from "./ApplicationStateful";
import {useTranslation} from "react-i18next";
import {modifyLast} from "../../../../common/src/utils/ArrayUtils";
import {matchPath} from "react-router";

export const resolvers = {

};

const BreadCrumbsStateful = () => {
  const {t} = useTranslation();
  const {pathname} = useLocation();
  const [{breadcrumbs}] = useContext(RouteContext);

  function resolve(resolver, match, name) {
    return name;
  }

  const crumbs = useMemo(() => {
    return modifyLast(
      breadcrumbs.reduce((result, route) => {
        const match = matchPath({path: route.fullPath, end: route.end}, pathname);
        if (match) {
          if (route.name) {
            result.push({
              url: match.pathname,
              name: resolve(route.resolver, match, route.name),
              active: match.pathname === pathname,
              resolver: route.resolver
            });
          } else {
            //if we have a matching URL without a name (no breadcrumb) we set current URL to previous breadcrumb. This way we can handle tabs
            modifyLast(result, (previous) => previous.url = match.pathname);
          }
        }
        return result;
      }, []),
      (last) => last.active = true);
  }, [breadcrumbs, pathname]);

  return (
    <nav className="section breadcrumb is-medium" aria-label="breadcrumbs">
      <ul>
        {
          crumbs.map(({url, resolver, active, name}, index) =>
            <li key={index}>
              <NavLink to={url} className={(resolver ? "has-max-width" : "")}>{name}</NavLink>
            </li>
          )
        }
      </ul>
    </nav>
  )
}

export default BreadCrumbsStateful;
